import { normalizePhoneTR } from './phoneUtils';

/** E-posta / giriş kimliği normalizasyonu — tek kaynak (SRP) */
export const normalizeEmail = (value) => {
  if (value == null) return '';
  return String(value).trim().toLowerCase();
};

export const emailsMatch = (a, b) => normalizeEmail(a) === normalizeEmail(b);

/** E-posta veya TR cep — Firestore `emailOrPhone` alanı */
export const normalizeEmailOrPhone = (value) => {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return '';
  if (trimmed.includes('@')) return normalizeEmail(trimmed);
  return normalizePhoneTR(trimmed) || normalizeEmail(trimmed);
};
